export const environment = {
  production: false,
  authApi: 'https://api.dev.appsensesolutions.com/auth/api',
  securityApi: 'https://api.dev.appsensesolutions.com/sec/api',
  chatbotApi: 'https://api.dev.appsensesolutions.com/chat/api',
  // chatbotApi: 'https://scrubber-chatbot-v2-789896578111.us-central1.run.app/api',
  environmentName: 'DEV',
  devAccount: {
    companyId: '1514516058',
    username: 'benzach.fire@gmail.com',
    password: 'Password123!',
  },
};
